import { RegisterCard } from "../../components/RegisterCard";
import { TimeSelect } from "../../components/TimeSelect";
import { CircleLoader } from "../../components/CircleLoader";
import { parseDateString } from "../../utilities/importantFns";
import { Droplets, Clock, GlassWater, PlusCircle } from "lucide-react";

export const CAliquid = ({
  formData,
  onFormChange,
  onFormSubmit,
  loading,
}: any) => {
  const parsedDate = formData?.time
    ? parseDateString(formData.time)
    : new Date();
  const liquidTypes = ["Water", "Breast Milk", "Milk", "Formula", "Other"];

  return (
    <div className="w-full max-w-4xl mx-auto p-4 animate-in fade-in duration-500">
      <RegisterCard
        title="Hydration"
        details="Record fluid intake for daily logs."
      />

      <form
        onSubmit={onFormSubmit}
        className="mt-6 bg-white rounded-[2.5rem] border border-slate-100 shadow-xl overflow-hidden flex flex-col lg:flex-row"
      >
        <div className="flex-1 p-8 space-y-8 order-2 lg:order-1">
          {/* Liquid Type */}
          <div className="space-y-3">
            <label className="flex items-center gap-2 text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              <Droplets size={14} className="text-blue-500" /> Liquid Type
            </label>
            <div className="flex flex-wrap gap-2">
              {liquidTypes.map((type) => (
                <button
                  key={type}
                  type="button"
                  onClick={() => onFormChange("liquid", type.toLowerCase())}
                  className={`px-4 py-2 rounded-xl text-sm font-bold border-2 transition-all
                    ${formData["liquid"] === type.toLowerCase() ? "bg-blue-600 border-blue-600 text-white" : "bg-slate-50 border-transparent text-slate-400 hover:bg-slate-100"}`}
                >
                  {type}
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-3">
              <label className="flex items-center gap-2 text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
                <Clock size={14} /> Time
              </label>
              <div className="h-12 border-2 border-slate-100 rounded-xl bg-slate-50 px-2 flex items-center">
                <TimeSelect
                  value={parsedDate}
                  onChange={(val: string) =>
                    onFormChange(
                      "time",
                      `${new Date().toISOString().split("T")[0]} ${val}`,
                    )
                  }
                />
              </div>
            </div>

            <div className="space-y-3">
              <label className="text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
                Quantity
              </label>
              <div className="flex bg-slate-100 p-1 rounded-xl">
                {["All", "Some", "None"].map((q) => (
                  <button
                    key={q}
                    type="button"
                    onClick={() => onFormChange("quantity", q.toLowerCase())}
                    className={`flex-1 py-2 rounded-lg font-bold text-xs transition-all ${formData["quantity"] === q.toLowerCase() ? "bg-white text-blue-600 shadow-sm" : "text-slate-400"}`}
                  >
                    {q}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <label className="text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              Notes
            </label>
            <textarea
              required
              value={formData["description"]}
              onChange={(e) => onFormChange("description", e.target.value)}
              className="w-full p-4 bg-slate-50 border-2 border-slate-100 rounded-2xl min-h-[100px] outline-none focus:border-blue-500 transition-all"
              placeholder="Any specifics (e.g., temperature, brand)..."
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full h-16 bg-slate-900 text-white rounded-2xl font-black uppercase tracking-widest hover:bg-black transition-all flex items-center justify-center gap-3"
          >
            {loading ? (
              <CircleLoader />
            ) : (
              <>
                <PlusCircle size={20} /> Log Liquid
              </>
            )}
          </button>
        </div>

        <div className="lg:w-64 bg-blue-50/50 flex items-center justify-center p-8 order-1 lg:order-2 border-l border-slate-100">
          <img
            src="/img/water-bottle.svg"
            className="w-40 h-40 animate-float"
            alt="water"
          />
        </div>
      </form>
    </div>
  );
};
